/**
 * isOwnerAdmin — fuente de verdad única para detectar las 3 cuentas
 * Admin permanentes de DamyxIA en el frontend.
 *
 * IMPORTANTE: Esta lista debe coincidir EXACTAMENTE con:
 *   - AUTHORIZED_ADMINS en /app/backend/routes/stats.py:192
 *   - /app/backend/services/owner_seed.py
 *   - /app/memory/test_credentials.md
 *
 * Decisión Marcelo (feb-2026): estos 3 emails tienen acceso PERMANENTE
 * a las opciones de Administración y Términos en el frontend, incluso
 * si el token en memoria se perdió (race condition / refresh / iframe reset).
 */

const OWNER_ADMIN_EMAILS = new Set([
  'damyxia@gmail.com',
  'marcmarl2@gmail.com',
  'manager@damyxia.com',
  'support@damyxia.com',
]);

/**
 * Lee el email actual del localStorage y verifica si está en la whitelist admin.
 * No depende del token en memoria (que puede quedar stale).
 */
export function isOwnerAdminEmail(email) {
  if (!email) return false;
  return OWNER_ADMIN_EMAILS.has(String(email).trim().toLowerCase());
}

/**
 * Util para el caso típico: detectar si el usuario actual (según localStorage)
 * es owner-admin permanente.
 */
export function isCurrentUserOwnerAdmin() {
  try {
    const e = localStorage.getItem('userEmail');
    return isOwnerAdminEmail(e);
  } catch {
    return false;
  }
}

export default OWNER_ADMIN_EMAILS;
